/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { LogRecord } from '../models/LogRecord';
import { Pagination } from '../models/Pagination';

/**
* Response from searching logs in text index.
*/
export class SearchLogsResponse {
  'pagination'?: Pagination;
  /**
  * The log records matching the search query.
  */
  'data'?: Array<LogRecord>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    },
    {
      "name": "data",
      "baseName": "data",
      "type": "Array<LogRecord>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SearchLogsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

